import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { userCrmIsLogged } from '../../../utils/authenticated-user';

const CrmPrivateRoute: React.FC<any> = () => {
  const isLogged = userCrmIsLogged();
  return isLogged ? <Outlet /> : <Navigate to='/admin' />;
};

export default CrmPrivateRoute;
